import { get, uploadFile, post } from './api';


export const getCategoryList = function (topCode) {
    return get('/search/category/childList', { topCode });
};

export const getBrandList = function (params) {
    return post('/index/queryBrandList', params);
};

export const goodsListByCategory = function (params) {
    return post('/index/queryGoodsList', params);
};

export const getQqList = function () {
    return get('/config/qqList');
};

export const getProductList = function (type, page, pageSize) {
    return get('/search/product/listByType', { type, page, pageSize });
};

export const getFeaturedList = function (limit, type) {
    return get('/search/product/getFeaturedList', { limit, type });
};

export const getNavList = function (params) {
    return post('/index/queryGoodsCategoryTreeList', params);
};
